import { render, staticRenderFns } from "./TestAccountForm.container.vue?vue&type=template&id=e9b90df4&"
import script from "./TestAccountForm.container.vue?vue&type=script&lang=ts&"
export * from "./TestAccountForm.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports